import axios from 'axios';

import { Client } from '@suntex.fim/api-client';
import { AuthService, SignOutReason } from '@suntex.fim/auth';

const HTTP_UNAUTHORIZED = 401;
const REQUEST_TIMEOUT_MS = 15_000;

export function initAxiosAuth(baseURL: string) {
  // eslint-disable-next-line import/no-named-as-default-member -- axios exposes a `create` method on the default export, but eslint-plugin-import flags it as a named export
  const axiosInstance = axios.create({
    baseURL,
    timeout: REQUEST_TIMEOUT_MS,
    headers: {
      'Content-Type': 'application/json',
    },

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    transformResponse: (data) => data,
  });

  const apiClient = new Client(baseURL, axiosInstance);

  const authService = new AuthService({
    apiClient,
  });

  axiosInstance.interceptors.request.use((config) => {
    const jwt = authService.getState().jwt;
    if (jwt) {
      config.headers.Authorization = `Bearer ${jwt}`;
    }
    return config;
  });

  axiosInstance.interceptors.response.use(undefined, (error: unknown) => {
    const status =
      error != null &&
      typeof error === 'object' &&
      'response' in error &&
      error.response != null &&
      typeof error.response === 'object' &&
      'status' in error.response
        ? error.response.status
        : undefined;

    const state = authService.getState();
    if (
      status === HTTP_UNAUTHORIZED &&
      state.isAuthenticated &&
      !state.signingOut
    ) {
      void authService.signOut({ reason: SignOutReason.Expired });
    }

    const rejection = error instanceof Error ? error : new Error(String(error));
    return Promise.reject(rejection);
  });

  return { apiClient, authService, axiosInstance };
}
